import { useLocale } from 'next-intl';
import { useCallback } from 'react';

import { trackingManager } from '@/lib/tracking/tracking-manager-instance';

interface CTATrackingParams {
  ctaLocation: string;
  ctaText: string;
  ctaType?: 'primary' | 'secondary';
  section: string;
  destinationUrl: string;
}

export function useLandingCTATracking() {
  const locale = useLocale();

  const trackCTAClick = useCallback(
    (params: CTATrackingParams) => {
      trackingManager.trackEvent('LANDING_CTA_CLICKED', {
        ctaLocation: params.ctaLocation,
        ctaText: params.ctaText,
        ctaType: params.ctaType || 'primary',
        section: params.section,
        destinationUrl: params.destinationUrl,
        language: locale,
      });
    },
    [locale],
  );

  return { trackCTAClick };
}
